import React from "react";
import PropTypes from "prop-types";
import { TestBox } from "../index";
import I18N from "../../I18N";
import "./recordStatus.scss";

const RecordDetails = ({ cameraType, record }) => {
  return (
    <div>
      <span>{cameraType}</span>
      <ul className="record-status__list">
        {Object.keys(record).map(prop => (
          <li key={prop} className="record-status__item">
            <span>{prop}</span>
            <span>{record[prop]}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const RecordStatus = ({ result, handleReTest }) => {
  const buttonRef = React.createRef();
  const { isLoading } = result;

  return (
    <TestBox
      testName={I18N.t("RECORD")}
      handleReTest={handleReTest}
      buttonRef={buttonRef}
      isLoading={isLoading}
    >
      {Object.keys(result).length > 0 ? (
        <div className="record-status">
          {Object.keys(result).map(camera => (
            <RecordDetails
              key={camera}
              cameraType={camera}
              record={result[camera]}
            />
          ))}
        </div>
      ) : (
        <div className="record-status__button-wrapper">
          <button
            onClick={() => {
              if (buttonRef && buttonRef.current) {
                buttonRef.current.click();
              }
            }}
            type="button"
            className="record-status__start-test-button"
          >
            {I18N.t("TEST_RECORD")}
          </button>
        </div>
      )}
    </TestBox>
  );
};

RecordStatus.propTypes = {
  result: PropTypes.object.isRequired,
  handleReTest: PropTypes.func.isRequired
};
RecordStatus.defaultProps = {};

export default RecordStatus;
